'use strict'

import { ready, on } from './dom'
import './tooltip.css'

var pane
var count = 0
var state = 'hide'
var stateNon = { top: 0, left: 0, elem: false, html: false }
var stateCur = assign({}, stateNon)

ready(function () {
  pane = document.createElement('div')
  pane.classList.add('Tooltip')
  pane.classList.add('tooltip-hidden')

  document.body.appendChild(pane)
})

function assign(target, source) {
  for (var key in source) {
    if (source.hasOwnProperty(key)) {
      target[key] = source[key]
    }
  }
  return target
}

var redraw = {
  __id: false,
  __func: function () {
    redraw.__id = false
    if (state !== 'show' || stateCur.html === false) {
      pane.classList.add('tooltip-hidden')
    } else {
      pane.innerHTML = stateCur.html
      pane.style.cssText = 'top: ' + stateCur.top + 'px; ' + ' left: ' + stateCur.left + 'px;'
      pane.classList.remove('tooltip-hidden')
    }
  },
  schedule: function () {
    if (redraw.__id === false) {
      redraw.__id = requestAnimationFrame(redraw.__func)
    }
  },
  cancel: function () {
    if (redraw.__id !== false) {
      cancelAnimationFrame(redraw.__id)
      redraw.__id = false
    }
  }
}

var timeout = {
  __id: false,
  __func: function () {
    timeout.__id = false
    state = 'show'
    redraw.schedule()
  },
  schedule: function () {
    if (timeout.__id === false) {
      timeout.__id = setTimeout(timeout.__func, 800)
    } else {
      throw 'timeout already scheduled!'
    }
  },
  cancel: function () {
    if (timeout.__id !== false) {
      clearTimeout(timeout.__id)
      timeout.__id = false
    } else {
      throw 'timeout not scheduled!'
    }
  }
}

var update = {
  __id: false,
  __posX: 0,
  __posY: 0,
  __func: function () {
    update.__id = false

    var elem = document.elementFromPoint(update.__posX + document.body.getClientRects()[0].left, update.__posY + document.body.getClientRects()[0].top)
    if (elem) {
      elem = elem.closest('[data-tooltip]:not([data-tooltip=""])')
    }

    var stateNew = {}
    if (elem) {
      if ( !elem.hasOwnProperty('__tooltip_id')) {
        elem.__tooltip_id = ++count
      }

      assign(stateNew, stateCur)

      stateNew.top = update.__posY
      stateNew.left = update.__posX
      stateNew.elem = elem.__tooltip_id
      stateNew.html = elem.getAttribute('data-tooltip')
    } else {
      assign(stateNew, stateNon)
    }

    switch (state) {
    case 'hide':
      if (stateNew.elem !== false) { // transition to wait
        state = 'wait'
        timeout.schedule()
      }
      break

    case 'wait':
      if (stateNew.elem) {
        if (stateNew.elem !== stateCur.elem) {
          timeout.cancel()
          timeout.schedule()
        }
      } else {
        state = 'hide'
        timeout.cancel()
      }
      break

    case 'show':
      if (stateNew.elem) {
        if (stateNew.elem !== stateCur.elem) {
          state = 'wait'
          timeout.schedule()
        }
      } else {
        state = 'hide'
      }
      redraw.schedule()
      break

    default:
      throw state
    }
    assign(stateCur, stateNew)
  },
  schedule: function (event) {
    if (event) {
      update.__posX = event.clientX - document.body.getClientRects()[0].left
      update.__posY = event.clientY - document.body.getClientRects()[0].top
    }
    if (update.__id === false) {
      update.__id = Promise.resolve().then(update.__func)
    }
  }
}

setInterval(update.schedule, 300)
on('mousemove', update.schedule)